var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"projects"},[_c('div',{staticClass:"project-list"},_vm._l((_vm.projects),function(project){return _c('div',{key:project.title},[_c('Project',{attrs:{"project":project}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }